import React, { useState, useEffect } from "react";
import FrontVideo from "../components/homevideo";
import HeaderTitle from "../components/headerTitle";
import axios from "axios";
import { API_BASE_URL } from "../config/config";
import WhatWeOffer from "../components/CommonSections/WhatWeOffer";
import Advantage from "../components/CommonSections/Advantage";
import Accordion from "../components/accordion";
import CtaBanner from "../components/CommonSections/CtaBanner";
import ColocationBannerForm from "../components/colocation-banner-from";
import PageLoader from "../components/home/pageload";
import MetaTag from "../components/CommonSections/MetaTag";
import ImgManagedCloudServices from "../assest/images/IshanManagedCloudServices.png";
import SubServiceSchema from "../components/CommonSections/subServicesSchema";
import "../sass/aws-certifications.scss";

const PAGE_KEY = "aws_services";

export default function AwsServices() {
  useEffect(() => {
    getData();
  }, []);

  const [awsServicesData, setAwsServicesData] = useState(null);
  const [settingResponse, setSettingResponse] = useState(null);

  const getData = () => {
    axios
      .post(`${API_BASE_URL}/api/awsservices/getAwsServices`)
      .then((response) => {
        setAwsServicesData(response);

        const generalSettingsData =
          response?.data?.data?.general_settings?.general_settings_data;
        const awsServicesSettingsData =
          generalSettingsData.find(
            (item) => item.tag === "aws_services_advantage",
          ) || null;
        const awsServicesSettingsResponse = JSON.parse(
          awsServicesSettingsData?.response || "{}",
        );
        awsServicesSettingsResponse.advantages = awsServicesSettingsResponse;
        setSettingResponse(awsServicesSettingsResponse);
      })
      .catch(() => {
        <PageLoader />;
      });
  };

  const getFaqSchema = () => {
    const faqData =
      awsServicesData?.data?.data?.[PAGE_KEY]?.aws_services_faq_data || [];
    return {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: faqData.map((faq) => ({
        "@type": "Question",
        name: faq.question,
        acceptedAnswer: {
          "@type": "Answer",
          text: faq.answerData || faq.answer.replace(/<[^>]*>?/gm, ""),
        },
      })),
    };
  };

  const bannerData =
    awsServicesData?.data?.data?.[PAGE_KEY]?.aws_services_banner_data?.[0];

  return (
    <>
      {awsServicesData === null ? (
        <PageLoader />
      ) : (
        <>
          <SubServiceSchema
            title={bannerData?.title}
            url="https://ishantechnologies.com/aws-services"
            parentTitle="Data Centre and Cloud Services"
            parentUrl="https://ishantechnologies.com/data-center-services"
          />
          <MetaTag data={awsServicesData} pageKey={PAGE_KEY} />
          <div className="page_heading responsive_heading">
            <div className="container">
              <HeaderTitle
                headerTitledata={awsServicesData}
                pageKey={PAGE_KEY}
              />
            </div>
          </div>
          <div
            className={`video hero-banner internet-banner ${
              !bannerData?.banner_title && !bannerData?.banner_img_desc
                ? "no-content"
                : ""
            }`}
          >
            <FrontVideo homeData={awsServicesData} pageKey={PAGE_KEY} />

            <div className="banner-content ">
              <div className="content-blk">
                {bannerData?.banner_title && (
                  <h2 className="home-heading">
                    {(() => {
                      const heading = bannerData.banner_title.trim();
                      const marker = "Enterprise Workloads";
                      const idx = heading.indexOf(marker);
                      // Break onto a second line at "Enterprise Workloads".
                      return idx > 0 ? (
                        <>
                          {heading.slice(0, idx).trim()}
                          <br />
                          {heading.slice(idx)}
                        </>
                      ) : (
                        heading
                      );
                    })()}
                  </h2>
                )}

                {bannerData?.banner_img_desc && (
                  <p className="para">{bannerData.banner_img_desc}</p>
                )}

                {bannerData?.button_img_name && (
                  <a href={bannerData.button_url}>
                    <button className="button hero-btn">
                      {bannerData.button_img_name}
                    </button>
                  </a>
                )}
              </div>
              <div className="form-blk">
                <ColocationBannerForm
                  homeData={awsServicesData}
                  pageName="Aws service"
                />
              </div>
            </div>
          </div>

          <div className="empowering section-space spin-wrap">
            <div className="spin-round-wrap">
              <div className="spin-round color-navy-blue">
                <span className="ballDot1">1</span>
                <span className="ballDot2">2</span>
                <span className="ballDot3">3</span>
                <span className="ballDot4">4</span>
              </div>
            </div>

            <div className="container">
              <div className="empowering-inner">
                <div className="empowering-left">
                  {
                    <img
                      src={ImgManagedCloudServices}
                      alt="AWS Services"
                      height={60}
                      width={60}
                      loading="lazy"
                    />
                  }
                </div>
                <div
                  className="empowering-right"
                  dangerouslySetInnerHTML={{
                    __html: awsServicesData?.data?.data?.[PAGE_KEY]
                      ?.aws_services_information_data[0]?.description,
                  }}
                ></div>
              </div>
            </div>
            <div className="spin-round-wrap">
              <div className="spin-round">
                <span className="ballDot1">1</span>
                <span className="ballDot2">2</span>
                <span className="ballDot3">3</span>
                <span className="ballDot4">4</span>
              </div>
            </div>
          </div>

          <div className="weoffer-bgdark">
            <WhatWeOffer
              title={settingResponse?.what_we_offer}
              data={
                awsServicesData?.data?.data?.[PAGE_KEY]?.aws_services_offer_data
              }
            />
          </div>

          {/* title prop omitted so the "Get in Touch" button is hidden on this page */}
          <Advantage
            data={
              awsServicesData?.data?.data?.[PAGE_KEY]
                ?.aws_services_advantages_data
            }
          />

          {awsServicesData?.data?.data?.[PAGE_KEY]
            ?.aws_services_certifications_data?.length > 0 && (
            <div className="aws-certifications">
              <div className="container">
                <h2 className="supercharge-heading aws-cert-heading">
                  Our AWS Certifications
                </h2>
                <div className="aws-cert-logos">
                  {awsServicesData.data.data[
                    PAGE_KEY
                  ].aws_services_certifications_data.map((cert, index) => (
                    <img
                      key={cert.id || index}
                      src={cert.image}
                      alt={cert.altText || "AWS Certification"}
                      loading="lazy"
                    />
                  ))}
                </div>
              </div>
            </div>
          )}

          {awsServicesData?.data?.data?.[PAGE_KEY]?.aws_services_faq_data
            ?.length > 0 && (
            <div className="frequently section-space">
              <div className="container">
                <h2 className="supercharge-heading">
                  Frequently Asked Questions (FAQs)
                </h2>

                <script
                  type="application/ld+json"
                  dangerouslySetInnerHTML={{
                    __html: JSON.stringify(getFaqSchema()),
                  }}
                />

                <Accordion
                  items={
                    awsServicesData?.data?.data?.[PAGE_KEY]?.aws_services_faq_data
                  }
                />
              </div>
            </div>
          )}

          <CtaBanner
            bannerData={
              awsServicesData?.data?.data?.[PAGE_KEY]
                ?.aws_services_cta_banner_data
            }
            extraButtons={[
              {
                label: "Case Study 1",
                url: `${process.env.PUBLIC_URL}/case-studies/ishan-technologies-aws-case-study.pdf`,
              },
              {
                label: "Case Study 2",
                url: `${process.env.PUBLIC_URL}/case-studies/sebi-ishan-technologies-aws-case-study.pdf`,
              },
            ]}
          />
        </>
      )}
    </>
  );
}
